// 发起结算
<template>
  <div id="containt">
        <div class="grid-height">


            <template>
              <div class="clearfix screen-btns" style=" padding-bottom: 3px;">
                <!-- <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog">工单导入
                  </vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-top"
                              @click="openEditDialog">工单导出
                  </vxe-button>
                </div> -->
                <div class="fl">
          <i class="el-icon-info" />
   <span>发起结算</span>
        </div>
                <div class="fr" style="display: flex;margin-top: 10px;">
                  <div style="margin-right:15px">

<el-button type="primary" plain class="button-sty"  @click="doSettle" icon="el-icon-s-grid">生成结算
</el-button>
</div>
                  <!-- <el-input placeholder="请输入工单号或用户联系方式" style="width: 200px;     height: 27px !important;"
                            v-model="searchValue" clearable>
                  </el-input> -->
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;height: 28px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>

                <vxe-form  ref="form" class="screen-box" title-width="7vw"  style="position: relative;"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent" >


<!--
                  <vxe-form-item title="时间类型:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.createBy" size="small"  style="width: 8vw !important; " clearable/>
                    </template>
                  </vxe-form-item>       -->




                  <div>
                  <vxe-form-item title="服务类型:" field="name">
                    <template v-slot>
                      <el-checkbox :indeterminate="serviceTypeIsIndeterminate" v-model="checkServiceTypeAll" @change="checkAllserviceType">全选</el-checkbox>
  <div style="margin: 15px 0;"></div>
  <el-checkbox-group v-model="serviceTypeChecked" @change="checkServiceTypeChange">
    <el-checkbox v-for="serviceType in serviceTypeOption" :label="serviceType.id" :key="serviceType.id">{{serviceType.name}}</el-checkbox>
  </el-checkbox-group>
                    </template>
                  </vxe-form-item>
                </div>
                <div style="width: 100%;">
                  <div style="display: block;">
                    <vxe-form-item title="完工时间:" field="name" style="position:absolute;top: 3px;">
                      <template v-slot>
                        <el-date-picker style="width: 16vw;height: 28px;" v-model="settleDate" type="daterange" align="right" unlink-panels
                                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
                                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                        </el-date-picker>
                      </template>
                    </vxe-form-item>
                    <vxe-form-item title="回访完成时间:" field="name" style="position:absolute;top: 3px;">
                      <template v-slot>
                        <el-date-picker style="width: 16vw;height: 28px;" v-model="recallDate" type="daterange" align="right" unlink-panels
                                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
                                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                        </el-date-picker>
                      </template>
                    </vxe-form-item>
                    <vxe-form-item title="进入结算池时间:" field="name" style="position:absolute;top: 3px;">
                      <template v-slot>
                        <el-date-picker style="width: 16vw;height: 28px;" v-model="applyDate" type="daterange" align="right" unlink-panels
                                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
                                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                        </el-date-picker>
                      </template>
                    </vxe-form-item>
<!--                   <vxe-form-item title=" " field="name" style="position:absolute;top: 3px;">-->
<!--                    <template v-slot>-->
<!--                      -->
<!--                    </template>-->
<!--                  </vxe-form-item>-->

                   <vxe-form-item title="结算网点:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.siteName" size="small" clearable @clear="clearName">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showProxySiteDialog=true"></i>
                      </el-input>
                    </template>
                  </vxe-form-item>
                </div>
                  <vxe-form-item title="品牌:" field="name">
                    <template v-slot style="display: block;">
                      <el-checkbox :indeterminate="brandIsIndeterminate" v-model="checkBrandAll" @change="checkAllBrand">全选</el-checkbox>

                        <el-checkbox-group v-model="brandChecked" @change="checkBrandChange">
                          <el-checkbox v-for="brand in brandOptions" :label="brand.id" :key="brand.id">{{brand.brandName}}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                  </vxe-form-item>
                </div>
                </vxe-form>

            </template>
            <div >
              <div style="border: 1px solid #ededed;height: calc(100vh - 190px);" class="grid-height" >
            <vxe-grid show-overflow  height="100%" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true,checkMethod:getIsSettle}"
                :showFooter='true'  :footer-method="footerMethod"
          >
          <template #num1_footer="{ items, _columnIndex }">
        <span>
          <el-button status="primary" size="mini">按钮</el-button>
          <span>累计：{{ items[_columnIndex] }}</span>
        </span>
      </template>
            <template #pager >
              <!-- <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage" ></pager> -->
              <div></div>
            </template>
          </vxe-grid></div>


        </div>
        </div>


    <auditDialog v-if="showAuditDialog"

                   @closeD="closeD"
                   :visiable.sync="showAuditDialog"
                   multi="true"
    />
<!-- 网点弹框 -->
<siteDialog v-if="showProxySiteDialog" @commit="commitSiteRow"
                 :visiable.sync="showProxySiteDialog" multi="true" :excludeId="dataId"
    />
  </div>
</template>

<script>

import auditDialog from './auditDialog.vue'
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
import zhiPaiDialog from '@/views/dialogCommon/assignSiteDialog.vue';
// 网点弹框
import siteDialog from "@/views/dialogCommon/radioSiteDialog.vue"
// const serviceType = [{id:1,name:'安装'}, {id:2,name:'维修'},{id:3,name:'保养'},{id:4,name:'咨询'},{id:5,name:'退机'},{id:6,name:'换机'},
//   {id:7,name:'检测'},{id:8,name:'鉴定'},{id:9,name:'勘测'},{id:10,name:'巡检'},{id:11,name:'客诉'},{id:12,name:'送修'},
//   {id:13,name:'表扬'},{id:19,name:'其他'},
// ];
const serviceType = [{id:1,name:'安装'}, {id:2,name:'维修'},{id:29,name:'其他'},
];
export default {
  name: 'launch',

  inject: ['reload'],
  components: { pager, auditDialog,
     // 网点弹框
     siteDialog},
  data() {
    return {
      showProxySiteDialog: false,

      checkBrandAll: false,
      checkServiceTypeAll: false,

      brandChecked: [],
      serviceTypeChecked: [],

      serviceTypeIsIndeterminate: false,
      brandIsIndeterminate: false,

      brandOptions: [],
      serviceTypeOption: serviceType,
      settleDate:null,
      recallDate:null,
      applyDate:null,
      selectSettleDateBegint:null,
      selectSettleDateEnd:null,
      selectRecallDateBegint:null,
      selectRecallDateEnd:null,
      selectApplyDateBegin:null,
      selectApplyDateEnd:null,
      selectBrandIds:[],
      selectServerTypeIds:[],
      formData: {
        siteName:'',
        siteId:"",
        isFirst:0,
        brandIds:[0],
        serverTypeIds:[0],
        timeType:3,
      },


      input: '',


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],

      showEdit: false,
      footerData: [
                ['和值', '666', '', '1', ''],
                ['平均', '', 'xx', '', '666']
              ],
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          title: '服务中心',
          field: 'orgName',
          width: 80,
        },
        {
          title: '服务商账号',
          field: 'siteLoginName',
          width: 100,
        },
        {
          title: '服务商名称',
          field: 'siteName',
          width: 100,
        },
        {
          title: '服务类型',
          field: 'settleTypeNames',
          width: 100,
        },
        {
          title: '品牌',
          field: 'brandNames',
          width: 100,
        },
        {
          title: '工单数量',
          field: 'orderQty',
          width: 120,
        },
        {
          title: '产品数量',
          field: 'machineQty',
          width: 100,
          // fixed: 'left'
        },
        {
          title: '安装费',
          field: 'azAmount',
          width: 80,
        },
        {
          title: '维修费',
          field: 'wxAmount',
          width: 80,
        },
        {
          title: '其他费',
          field: 'otherAmount',
          width: 80,
        },
        {
          title: '总服务费',
          field: 'siteAmount',
          width: 80,
        },
        {
          title: '奖罚金额',
          field: 'rewardAmount',
          width: 80,

        },
        {
          title: '红利',
          field: 'bonusFee',
          width: 80,

        },
        {
          title: '安装远程费',
          field: 'azDistanceAmount',
          width: 100,
        },
        {
          title: '维修远程费',
          field: 'wxDistanceAmount',
          width: 100,
        },
        {
          title: '其他远程费',
          field: 'otherDistanceAmount',
          width: 100,
        },
        {
          title: '总远程费',
          field: 'longDistanceAmount',
          width: 100,
        },
        {
          title: '特设费用',
          field: 'specialAmount',
          width: 100,
        },
        {
          title: '安装考核费用',
          field: 'azKaoheAmount',
          width: 100,
        },
        {
          title: '维修考核费用',
          field: 'wxKaoheAmount',
          width: 100,
        },
        {
          title: '其他考核费用',
          field: 'otherKaoheAmount',
          width: 100,
        },
        {
          title: '总考核费用',
          field: 'kaoheAmount',
          width: 100,
        },
        {
          title: '安装结算补扣',
          field: 'azBukouAmount',
          width: 100,
        },
        {
          title: '维修结算补扣',
          field: 'wxBukouAmount',
          width: 100,
        },
        {
          title: '其他结算补扣',
          field: 'otherBukouAmount',
          width: 100,
        },
        {
          title: '总结算补扣',
          field: 'bukouAmount',
          width: 100,
        },
        {
          title: '安装特殊费用',
          field: 'azTeshuAmount',
          width: 100,
        },
        {
          title: '维修特殊费用',
          field: 'wxTeshuAmount',
          width: 100,
        },
        {
          title: '其他特殊费用',
          field: 'otherTeshuAmount',
          width: 100,
        },
        {
          title: '总特殊费用申请',
          field: 'teshuAmount',
          width: 100,
        },
        {
          title: '销售激励金额',
          field: 'saleRewardAmount',
          width: 100,
        },
        {
          title: '激励调整金额',
          field: 'saleRewardAdjustAmount',
          width: 100,
        },
        {
          title: '安装激励费用',
          field: 'azWkRewardAmount',
          width: 100,
        },
        {
          title: '维修激励费用',
          field: 'wxWkRewardAmount',
          width: 100,
        },
        {
          title: '其他激励费用',
          field: 'otherWkRewardAmount',
          width: 100,
        },
        {
          title: '总激励费用',
          field: 'wkRewardAmount',
          width: 100,
        },
        {
          title: '安装奖惩费用',
          field: 'azWkPunishAmount',
          width: 100,
        },
        {
          title: '维修奖惩费用',
          field: 'wxWkPunishAmount',
          width: 100,
        },
        {
          title: '其他奖惩费用',
          field: 'otherWkPunishAmount',
          width: 100,
        },
        {
          title: '总奖惩费用',
          field: 'wkPunishAmount',
          width: 100,
        },

      ],
      columnsFeeAttribute:[],
      columnsEnd :[
        {
          title: '总安装费用',
          field: 'siteAzAmount',
          width: 80,

        },
        {
          title: '总维修费用',
          field: 'siteWxAmount',
          width: 80,

        },
        {
          title: '总其他费用',
          field: 'siteOtherAmount',
          width: 80,

        },
        {
        title: '总金额',
        field: 'amount',
        width: 80,

      },
        {
          title: '是否允许结算',
          field: 'isSettle',
          width: 120,
          slots: {
            default: ({row}) => {
              if (row.isSettle == 1) {
                return [
                  <div>
                  <span>是</span>
                  </div>
              ];
              } else if (row.isSettle == 0) {
                return [
                  <div>
                  <span>否</span>
                  </div>
              ];
              }
            }
          }
        },]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
  },

  mounted() {
    this.loadBrandOption()
    this.getTableData();
    this.checkAllserviceType(true);
    this.initSearchDate();
    this.getSettleFeeAttribute()
  },

  methods: {
    toFilterData() {
            this.searchEvent();
     },
    clearName(){
      console.log(363);
      this.formData.siteName=''
      this.formData.siteId=''
    },

        commitSiteRow(data) {
      // this.formData.snSiteInfoDTO.settleSiteId = data.id
      this.formData.siteId = data.id;
      this.formData.siteName = data.name;

    },
    sumNum (list, field) {
              let count = 0
              list.forEach(item => {
                count += Number(item[field])
              })
              return count
            },
    footerMethod ({ columns, data }) {
              return [
                columns.map((column, index) => {
                  if (index === 0) {
                    return '合计:'
                  } else if (!['orgName', 'siteLoginName','siteName','settleTypeNames','brandNames','stat','isSettle'].includes(column.property)) {
                    return this.sumNum(data, column.property)
                  }
                  return null
                })
              ]
            },
    //获取自定义费用明细
    getSettleFeeAttribute(){
      // this.$http({
      //   url: api.sfBatchSettle.getSettleFeeAttributeUrl,
      //   method: 'post',
      // }).then(res => {
      //   res.data.data.forEach(item => {
      //     this.columnsFeeAttribute.push({
      //       title: item.attributeName,
      //       field: item.feeAttributeId,
      //       width: 80,
      //     })
      //   })
      //   this.columns.push(... this.columnsFeeAttribute)
        this.columns.push(...this.columnsEnd)
      // })
    },

// 服务类型全选
   checkAllserviceType(val) {
        this.serviceTypeChecked = val ? this.serviceTypeOption.map(item => item.id) : []
        this.serviceTypeIsIndeterminate = false;
        this.formData.serverTypeIds = [];
     if (val){
       this.formData.serverTypeIds.push(0);
       this.checkServiceTypeAll = true
       this.formData.isAllServerType = 1
     }else{
       this.formData.isAllServerType = 0
     }
      },
    //服务类型选择
    checkServiceTypeChange(value) {
        this.formData.serverTypeIds = [];
        let checkedCount = value.length;
        this.checkServiceTypeAll = checkedCount === this.serviceTypeOption.length;
      if( this.checkServiceTypeAll){
        this.formData.serverTypeIds.push(0);
        this.formData.isAllServerType = 1
      }else{
        this.formData.isAllServerType = 0
        const serverTypeIds = [];
        for (let i = 0; i < checkedCount; i++) {
          serverTypeIds.push(value[i])
        }
        this.serviceTypeChecked = serverTypeIds;
        this.formData.serverTypeIds = serverTypeIds;
      }
        this.serviceTypeIsIndeterminate = checkedCount > 0 && checkedCount < this.serviceTypeOption.length;
      },



      // 品牌全选
    checkAllBrand(val) {
      this.brandChecked = val ? this.brandOptions.map(item => item.id) : []
      this.brandIsIndeterminate = false
      this.formData.brandIds = [];
      if (val){
        this.formData.brandIds.push(0);
        this.checkBrandAll = true
        this.formData.isAllBrandId = 1
      }else {
        this.formData.isAllBrandId = 0
      }
      },
    //品牌单选
    checkBrandChange(value){
      this.formData.brandIds = [];
      let checkedCount = value.length;
      this.checkBrandAll = checkedCount === this.brandOptions.length;
      if( this.checkBrandAll){
        this.formData.brandIds = [];
        this.formData.brandIds.push("0");
        this.formData.isAllBrandId = 1
      }else{
        this.formData.isAllBrandId = 0
        const brandIds = [];
        for (let i = 0; i < checkedCount; i++) {
          brandIds.push(value[i])
        }
        this.brandChecked = brandIds;
        this.formData.brandIds = brandIds;
      }
      this.brandIsIndeterminate = checkedCount > 0 && checkedCount < this.brandOptions.length;
    },
    //初始化时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.settleDate = [start, end]
      this.formData.settleDateBegint = start;
      this.formData.settleDateEnd = end;

      this.recallDate = [start, end]
      this.formData.recallDateBegint = start;
      this.formData.recallDateEnd = end;

      this.applyDate = [start, end]
      this.formData.applyDateBegin = start;
      this.formData.applyDateEnd = end;
    },
        //抽屉关闭后改变父组件的visible的值
        closeD(v) {
      // this.showConfirmDialog = false
      // this.showCloseDialog = false
      this.showAuditDialog = false
      // this.flushed()
    },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },


    // 服务商提示选中
    handleSiteSelect(data) {
      this.formData.siteId = data.id
    },


    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: api.snCompanyBrand.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
          this.brandOptions= res.data.data
        this.checkAllBrand(true)
      })
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.sfBatchSettle.getBatchSettleUrl,
        param: this.formData,
        method: 'post',
        columns: this.columns,
        isPage:1
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },
    getIsSettle({row}){
      if (row.isSettle == 1){
        return true;
      }else{
        return false;
      }
    },
    //判断数组是否一致
    isSame(a,b){
      if (a.length == b.length) {
        //every() 每一个都是true则返回true，如果有一个是false，那么直接返回false；
        var isIn = 0
        let p = a.every((item, index) => {
          //判断的条件为a数组的每一项在b数组内查找不等于-1就代表有，有就为true，所有都是true就返回true
           if(b.indexOf(item) === -1){
             isIn = -1
           }
        });
        if (isIn == -1){
          return false
        }
        return true;
      } else {
        //这里写长度不一致也就是错误的时候的操作。比如提示答案错误
        console.log("长度不一致，错误");
        return false;
      }
    },
    //发起结算
    doSettle(){
      //判断查询条件是否一致
      if(this.selectSettleDateBegint != this.formData.settleDateBegint ||  this.selectSettleDateEnd != this.formData.settleDateEnd){
        this.$message.warning('完工时间调整了,请先重新查询！')
        return
      }
      //判断查询条件是否一致
      if(this.selectRecallDateBegint != this.formData.recallDateBegint ||  this.selectRecallDateEnd != this.formData.recallDateEnd){
        this.$message.warning('回访时间调整了,请先重新查询！')
        return
      }
      //判断查询条件是否一致
      if(this.selectApplyDateBegin != this.formData.applyDateBegin ||  this.selectApplyDateEnd != this.formData.applyDateEnd){
        this.$message.warning('回访时间调整了,请先重新查询！')
        return
      }
      if (!this.isSame(this.selectBrandIds,this.formData.brandIds)){
        this.$message.warning('品牌调整了,请先重新查询！')
        return
      }
      if (!this.isSame(this.selectServerTypeIds,this.formData.serverTypeIds)){
        this.$message.warning('服务类型调整了,请先重新查询！')
        return
      }
      const selectedRows = this.$refs['table-m1'].getCheckboxRecords(); // 获取选中行
      if(selectedRows.length==0){
        this.$message.warning('请勾选需要发起结算的服务商')
        return
      }else{
        const siteIds =[]
        selectedRows.forEach(item =>{
          siteIds.push(item.siteId)
        })
        this.formData.siteIds = siteIds
      }

      this.$baseConfirm('您确定要发起结算吗？').then(() => {
        this.$http({
          url: api.sfBatchSettle.doSettleUrl,
          method: 'post',
          data:this.formData,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if(response.data.type == "success"){
            this.$message({ message:response.data.content,type: 'success'});
            this.searchEvent();
          }else{
            this.$message({ message:response.data.content,type: 'warning'});
          }
        })
      })
    },

    // 搜索
    searchEvent() {
      this.formData.isFirst =1;
      if (this.settleDate && this.settleDate.length!=0){
        this.formData.settleDateBegint = this.settleDate[0];
        this.formData.settleDateEnd = this.settleDate[1];
      }else {
        this.formData.settleDateBegint = null;
        this.formData.settleDateEnd = null;
      }
      if (this.recallDate && this.recallDate.length!=0){
        this.formData.recallDateBegint = this.recallDate[0];
        this.formData.recallDateEnd = this.recallDate[1];
      }else {
        this.formData.recallDateBegint = null;
        this.formData.recallDateEnd = null;
      }
      if (this.applyDate && this.applyDate.length!=0){
        this.formData.applyDateBegin = this.applyDate[0];
        this.formData.applyDateEnd = this.applyDate[1];
      }else {
        this.formData.applyDateBegin = null;
        this.formData.applyDateEnd = null;
      }
      this.formData.siteIds = []
      if(this.formData.isAllBrandId == 0 && this.formData.brandIds.length==0){
        this.$message.warning('请选择对应的品牌')
        return
      }
      if(this.formData.isAllServerType == 0 && this.formData.serverTypeIds.length==0){
        this.$message.warning('请选择对应的服务类型')
        return
      }
      this.flushed()
      this.selectSettleDateBegint = this.formData.settleDateBegint;
      this.selectSettleDateEnd = this.formData.settleDateEnd;
      this.selectRecallDateBegint = this.formData.recallDateBegint;
      this.selectRecallDateEnd = this.formData.recallDateEnd;
      this.selectApplyDateBegin = this.formData.applyDateBegin;
      this.selectApplyDateEnd = this.formData.applyDateEnd;
      this.selectBrandIds = this.formData.brandIds
      this.selectServerTypeIds = this.formData.serverTypeIds
    },

  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}
.screen-btns .fl{
    margin: 19px 0px 0px 0px;
    padding: 0px 10px 0 14px;
    font-size: 13px;
    overflow: hidden;
    background-color: #FFF;
i {
  color: #00c4b3;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  margin-bottom: 1px;
  font-size: 14px;
  font-size: 14px;
}
span{
  font-size: 13px;
}}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
::v-deep .vxe-grid .vxe-form.screen-box {
    padding: 4px 10px 2px 0;
    }
::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
    display: inline-block;
    width: 20%;
}
::v-deep .vxe-grid .el-input .el-input__inner {
    height: 28px !important;
}
.screen-box{
 background-color: #F4F6FA;
}
::v-deep .vxe-form .vxe-form--item {
  padding: 0;
}
.title_btn{
  background-color: #bad5ef;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 2px 1px;
}
::v-deep  .el-range-editor--medium .el-range__icon {
    line-height: 22px !important;
}
::v-deep .vxe-form--item .vxe-form--item-inner .vxe-form--item-content {
    display: flex!important;
  padding-top: 10px;
}
.el-checkbox:last-of-type {
    margin-right: 20px!important;
}
::v-deep .el-checkbox__label, body .el-radio__label {
    width: 3vw;
}
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell {
  width: 7vw;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    /* width: 6vw; */
}
::v-deep .vxe-grid .vxe-table--footer-wrapper.body--wrapper {
    z-index: 9;
    color: #2196f3;
    font-weight: 600;
}
</style>
